import { ApiClient } from "../ApiClient";
import config from "../utils/config";
class CategoriesApiClient {
    constructor() {
        this.apiClient = new ApiClient(`${config.gatewayApiUrl}/categories`);
    }
    getAuctionCategory(id, auctionId) {
        const queryString = new URLSearchParams();
        if (auctionId) {
            queryString.append("auctionId", auctionId.toString());
        }
        return this.apiClient.get(`/${id}?${queryString.toString()}`);
    }
    getRootAuctionCategory(auctionId) {
        var _a;
        return this.apiClient.get(`/root?auctionId=${(_a = auctionId === null || auctionId === void 0 ? void 0 : auctionId.toString()) !== null && _a !== void 0 ? _a : ""}`);
    }
}
const categoriesApiClient = new CategoriesApiClient();
export default categoriesApiClient;
